/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfBoolean } from '../models/platform-api-result-of-boolean';
import { PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto } from '../models/platform-api-result-of-data-source-result-dto-of-i-ching-consultation-dto';
import { PlatformApiResultOfIChingConsultationDto } from '../models/platform-api-result-of-i-ching-consultation-dto';
import { PlatformApiResultOfIChingImportResultDto } from '../models/platform-api-result-of-i-ching-import-result-dto';
import { PlatformApiResultOfListOfIChingConsultationExportDto } from '../models/platform-api-result-of-list-of-i-ching-consultation-export-dto';
import { PlatformApiResultOfListOfIChingConsultationMarkerDto } from '../models/platform-api-result-of-list-of-i-ching-consultation-marker-dto';
import { getIchingConsultationsMineExport } from '../fn/i-ching/get-iching-consultations-mine-export';
import { GetIchingConsultationsMineExport$Params } from '../fn/i-ching/get-iching-consultations-mine-export';
import { getIchingConsultationsMineForChartChartid } from '../fn/i-ching/get-iching-consultations-mine-for-chart-chartid';
import { GetIchingConsultationsMineForChartChartid$Params } from '../fn/i-ching/get-iching-consultations-mine-for-chart-chartid';
import { getIchingConsultationsMineId } from '../fn/i-ching/get-iching-consultations-mine-id';
import { GetIchingConsultationsMineId$Params } from '../fn/i-ching/get-iching-consultations-mine-id';
import { postIchingConsultationsActionCreate } from '../fn/i-ching/post-iching-consultations-action-create';
import { PostIchingConsultationsActionCreate$Params } from '../fn/i-ching/post-iching-consultations-action-create';
import { postIchingConsultationsActionDelete } from '../fn/i-ching/post-iching-consultations-action-delete';
import { PostIchingConsultationsActionDelete$Params } from '../fn/i-ching/post-iching-consultations-action-delete';
import { postIchingConsultationsActionImport } from '../fn/i-ching/post-iching-consultations-action-import';
import { PostIchingConsultationsActionImport$Params } from '../fn/i-ching/post-iching-consultations-action-import';
import { postIchingConsultationsActionUpdate } from '../fn/i-ching/post-iching-consultations-action-update';
import { PostIchingConsultationsActionUpdate$Params } from '../fn/i-ching/post-iching-consultations-action-update';
import { postIchingConsultationsMineQueryDatasource } from '../fn/i-ching/post-iching-consultations-mine-query-datasource';
import { PostIchingConsultationsMineQueryDatasource$Params } from '../fn/i-ching/post-iching-consultations-mine-query-datasource';


/**
 * I Tjing-dagboek (Classic I Ching). Elke gebruiker ziet en wijzigt enkel de eigen
 * raadplegingen; de eigenaar komt altijd uit de ingelogde gebruiker, nooit uit de body.
 */
@Injectable({ providedIn: 'root' })
export class PlatformIChingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postIchingConsultationsActionCreate()` */
  static readonly PostIchingConsultationsActionCreatePath = '/api/iching/consultations/action/create';

  /**
   * Slaat een nieuwe raadpleging op. PrimaryHexagram en ChangedHexagram berekent de server
   * uit de lijnen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postIchingConsultationsActionCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionCreate$Response(params: PostIchingConsultationsActionCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>> {
    return postIchingConsultationsActionCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Slaat een nieuwe raadpleging op. PrimaryHexagram en ChangedHexagram berekent de server
   * uit de lijnen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postIchingConsultationsActionCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionCreate(params: PostIchingConsultationsActionCreate$Params, context?: HttpContext): Observable<PlatformApiResultOfIChingConsultationDto> {
    return this.postIchingConsultationsActionCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>): PlatformApiResultOfIChingConsultationDto => r.body)
    );
  }

  /** Path part for operation `postIchingConsultationsActionUpdate()` */
  static readonly PostIchingConsultationsActionUpdatePath = '/api/iching/consultations/action/update';

  /**
   * Werkt de reflectievelden van een eigen raadpleging bij (vraag, trefwoorden, notities,
   * doe/laat-lijsten, herbekeken op, gekoppelde chart). De worp zelf blijft ongewijzigd.
   * Volledige vervanging van de notitievelden; de client stuurt alle velden mee, ook
   * RevisitedOn en LinkedChartId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postIchingConsultationsActionUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionUpdate$Response(params: PostIchingConsultationsActionUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>> {
    return postIchingConsultationsActionUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Werkt de reflectievelden van een eigen raadpleging bij (vraag, trefwoorden, notities,
   * doe/laat-lijsten, herbekeken op, gekoppelde chart). De worp zelf blijft ongewijzigd.
   * Volledige vervanging van de notitievelden; de client stuurt alle velden mee, ook
   * RevisitedOn en LinkedChartId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postIchingConsultationsActionUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionUpdate(params: PostIchingConsultationsActionUpdate$Params, context?: HttpContext): Observable<PlatformApiResultOfIChingConsultationDto> {
    return this.postIchingConsultationsActionUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>): PlatformApiResultOfIChingConsultationDto => r.body)
    );
  }

  /** Path part for operation `postIchingConsultationsActionImport()` */
  static readonly PostIchingConsultationsActionImportPath = '/api/iching/consultations/action/import';

  /**
   * Importeert raadplegingen uit een dagboekexport in het eigen dagboek. Ongeldige items en
   * raadplegingen die al bestaan (zelfde tijdstip, worp en vraag) worden overgeslagen; een
   * chart blijft gekoppeld wanneer het id of een unieke naam bij een eigen chart hoort.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postIchingConsultationsActionImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionImport$Response(params: PostIchingConsultationsActionImport$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingImportResultDto>> {
    return postIchingConsultationsActionImport(this.http, this.rootUrl, params, context);
  }

  /**
   * Importeert raadplegingen uit een dagboekexport in het eigen dagboek. Ongeldige items en
   * raadplegingen die al bestaan (zelfde tijdstip, worp en vraag) worden overgeslagen; een
   * chart blijft gekoppeld wanneer het id of een unieke naam bij een eigen chart hoort.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postIchingConsultationsActionImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionImport(params: PostIchingConsultationsActionImport$Params, context?: HttpContext): Observable<PlatformApiResultOfIChingImportResultDto> {
    return this.postIchingConsultationsActionImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfIChingImportResultDto>): PlatformApiResultOfIChingImportResultDto => r.body)
    );
  }

  /** Path part for operation `postIchingConsultationsActionDelete()` */
  static readonly PostIchingConsultationsActionDeletePath = '/api/iching/consultations/action/delete';

  /**
   * Verwijdert een eigen raadpleging; false wanneer ze niet bestond.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postIchingConsultationsActionDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionDelete$Response(params: PostIchingConsultationsActionDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postIchingConsultationsActionDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Verwijdert een eigen raadpleging; false wanneer ze niet bestond.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postIchingConsultationsActionDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsActionDelete(params: PostIchingConsultationsActionDelete$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postIchingConsultationsActionDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `getIchingConsultationsMineId()` */
  static readonly GetIchingConsultationsMineIdPath = '/api/iching/consultations/mine/{id}';

  /**
   * Eén eigen raadpleging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIchingConsultationsMineId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIchingConsultationsMineId$Response(params: GetIchingConsultationsMineId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>> {
    return getIchingConsultationsMineId(this.http, this.rootUrl, params, context);
  }

  /**
   * Eén eigen raadpleging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIchingConsultationsMineId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIchingConsultationsMineId(params: GetIchingConsultationsMineId$Params, context?: HttpContext): Observable<PlatformApiResultOfIChingConsultationDto> {
    return this.getIchingConsultationsMineId$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>): PlatformApiResultOfIChingConsultationDto => r.body)
    );
  }

  /** Path part for operation `getIchingConsultationsMineExport()` */
  static readonly GetIchingConsultationsMineExportPath = '/api/iching/consultations/mine/export';

  /**
   * Het eigen dagboek voor export, oplopend op tijdstip van raadpleging, met de naam van de
   * gekoppelde chart; met id enkel die raadpleging (lege lijst wanneer ze niet bestaat).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIchingConsultationsMineExport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIchingConsultationsMineExport$Response(params?: GetIchingConsultationsMineExport$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationExportDto>> {
    return getIchingConsultationsMineExport(this.http, this.rootUrl, params, context);
  }

  /**
   * Het eigen dagboek voor export, oplopend op tijdstip van raadpleging, met de naam van de
   * gekoppelde chart; met id enkel die raadpleging (lege lijst wanneer ze niet bestaat).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIchingConsultationsMineExport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIchingConsultationsMineExport(params?: GetIchingConsultationsMineExport$Params, context?: HttpContext): Observable<PlatformApiResultOfListOfIChingConsultationExportDto> {
    return this.getIchingConsultationsMineExport$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationExportDto>): PlatformApiResultOfListOfIChingConsultationExportDto => r.body)
    );
  }

  /** Path part for operation `getIchingConsultationsMineForChartChartid()` */
  static readonly GetIchingConsultationsMineForChartChartidPath = '/api/iching/consultations/mine/for-chart/{chartId}';

  /**
   * Markers van de eigen raadplegingen die bij een chart horen, voor de levenstijdlijn en de
   * kalenders; met includeUnlinked ook de raadplegingen zonder chart. Oplopend op tijdstip.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIchingConsultationsMineForChartChartid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIchingConsultationsMineForChartChartid$Response(params: GetIchingConsultationsMineForChartChartid$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationMarkerDto>> {
    return getIchingConsultationsMineForChartChartid(this.http, this.rootUrl, params, context);
  }

  /**
   * Markers van de eigen raadplegingen die bij een chart horen, voor de levenstijdlijn en de
   * kalenders; met includeUnlinked ook de raadplegingen zonder chart. Oplopend op tijdstip.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIchingConsultationsMineForChartChartid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIchingConsultationsMineForChartChartid(params: GetIchingConsultationsMineForChartChartid$Params, context?: HttpContext): Observable<PlatformApiResultOfListOfIChingConsultationMarkerDto> {
    return this.getIchingConsultationsMineForChartChartid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfListOfIChingConsultationMarkerDto>): PlatformApiResultOfListOfIChingConsultationMarkerDto => r.body)
    );
  }

  /** Path part for operation `postIchingConsultationsMineQueryDatasource()` */
  static readonly PostIchingConsultationsMineQueryDatasourcePath = '/api/iching/consultations/mine/query/datasource';

  /**
   * Eigen dagboek, gepagineerd: zoeken en paging via de DataSourceQuery, hexagram (1..64) als
   * vast filter dat zowel het primaire als het veranderde hexagram matcht. Zonder
   * SortOptions: meest recente tijdstip van raadpleging eerst.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postIchingConsultationsMineQueryDatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsMineQueryDatasource$Response(params: PostIchingConsultationsMineQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto>> {
    return postIchingConsultationsMineQueryDatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * Eigen dagboek, gepagineerd: zoeken en paging via de DataSourceQuery, hexagram (1..64) als
   * vast filter dat zowel het primaire als het veranderde hexagram matcht. Zonder
   * SortOptions: meest recente tijdstip van raadpleging eerst.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postIchingConsultationsMineQueryDatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postIchingConsultationsMineQueryDatasource(params: PostIchingConsultationsMineQueryDatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto> {
    return this.postIchingConsultationsMineQueryDatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto>): PlatformApiResultOfDataSourceResultDtoOfIChingConsultationDto => r.body)
    );
  }

}
